import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface SettingTab {
  link: string;
  /** Prefijo de ruta con que la pestaña se considera activa. */
  match: string;
  label: string;
  icon: string;
  purpose: string;
}

/** Contenedor de Configuración: encabezado y pestañas, con el mismo patrón que Supervisión. */
@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css'],
})
export class SettingComponent {
  tabs: SettingTab[] = [
    { link: '/configuracion/empresa/general', match: '/configuracion/empresa/general', label: 'Empresa', icon: 'fa-building', purpose: 'Información general de su empresa: razón social, datos de contacto y facturación.' },
    { link: '/configuracion/empresa/sms', match: '/configuracion/empresa/sms', label: 'SMS', icon: 'fa-comment-sms', purpose: 'Configuración del envío de SMS y su historial.' },
    { link: '/configuracion/categorias', match: '/configuracion/categorias', label: 'Categorías', icon: 'fa-tags', purpose: 'Categorías con que se clasifican las incidencias de guardias, supervisores y de la central. Puede crear, editar y eliminar las que necesite.' },
    { link: '/configuracion/colaboradores/listar', match: '/configuracion/colaboradores/listar', label: 'Colaboradores', icon: 'fa-users', purpose: 'Usuarios del sistema: administradores, supervisores, centralistas y administradores de instalación. Los supervisores son los mismos que usan la app de supervisión.' },
    { link: '/configuracion/colaboradores/perfil', match: '/configuracion/colaboradores/perfil', label: 'Mi perfil', icon: 'fa-id-badge', purpose: 'Sus datos personales y su clave de acceso.' },
  ];

  /** Si el panel de ayuda está desplegado. */
  helpOpen = false;

  constructor(private router: Router) {}

  /** Pestaña activa según la URL actual. */
  get current(): SettingTab {
    const url = this.router.url.split('?')[0].split('#')[0];
    return this.tabs.find((t) => url.startsWith(t.match)) || (url.startsWith('/configuracion/colaboradores') ? this.tabs[3] : this.tabs[0]);
  }
}
